import {t} from '@lingui/macro'
import React from 'react'
import {Helmet} from 'react-helmet'

import {LoginFlow} from '../otp/login'

export function Login() {
    return (
        <>
            <Helmet>
                <title>{t`Log in`}</title>
            </Helmet>
            <LoginFlow />
        </>
    )
}
export default Login
